import React from 'react'
import PropTypes from 'prop-types'
import Counter from '../../components/Counter/Counter'

const AncillariesContentBlock = ({
  title,
  iconName,
  handleChange,
  maxValue,
  luggageBalance,
  name,
  value,
  isValid,
  errorMessage,
  validate,
}) => (
  <div className="ancillaries__wrapper">
    <span>
      <Counter
        counterValue={value}
        step={1}
        minValue={0}
        maxValue={luggageBalance ? maxValue - luggageBalance : maxValue}
        handleChange={handleChange}
        name={name}
        label={title}
        iconName={iconName}
        customClassName="ancillaries"
        validate={validate}
      />
    </span>
    {isValid === false && errorMessage ? (
      <span className="ancillaries__error-message">{errorMessage}</span>
    ) : (
      undefined
    )}
  </div>
)

AncillariesContentBlock.propTypes = {
  title: PropTypes.string,
  iconName: PropTypes.string,
  handleChange: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.number,
  maxValue: PropTypes.number,
  luggageBalance: PropTypes.number,
  validate: PropTypes.func,
  isValid: PropTypes.bool,
  errorMessage: PropTypes.string,
}
export default AncillariesContentBlock
